import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LoginService } from '../login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../core/services/notification/notification.service';
import { ResetPasswordData } from '../login.model';
import { TranslatorService } from '../../core/translator/translator.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  @ViewChild('resetPasswordForm') resetPasswordForm: NgForm;

  private resetPasswordData: ResetPasswordData = new ResetPasswordData();
  private repeatedPassword: string;
  public showErrorMessage: boolean;
  public showInfoMessage: boolean;
  public hide: boolean;

  private message: string;
  private token: string;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private translateService: TranslatorService,
    private notificationService: NotificationService,
    private activatedRoute: ActivatedRoute
  ) {
    this.hide = true;
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.queryParams['user']) {
      this.activatedRoute.queryParams.subscribe(params => {
        this.resetPasswordData.userName = params['user'];
      });
    }
  }

  public resetPassword() {
    if (this.resetPasswordData.password !== this.repeatedPassword) {
      this.showError('LOGIN_diffrentPassword');
      return;
    }

    this.resetPasswordData.token = this.token;
    this.loginService.resetPassword(this.resetPasswordData).subscribe(() => {
      this.showMessage('LOGIN_resetPassword');
      setTimeout(() => this.router.navigate(['login']), 4000);
    });
  }

  showMessage(translateMessage: string) {
    this.translateService.translate.get(translateMessage).subscribe(
      (value) => {
        this.message = value;
        this.showInfoMessage = true;
        // sweetAlert(value);
        setTimeout(() => this.showInfoMessage = false, 3000);
      });
  }

  showError(errorMessage: string) {
    this.translateService.translate.get(errorMessage).subscribe(
      (value) => {
        this.message = value;
        this.showErrorMessage = true;
        setTimeout(() => this.showErrorMessage = false, 5000);
      });
  }
}
